import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { trpc } from '@web/lib/trpc';

import { PublicPaymentView } from '@web/payments/views';
import { CollectPaymentForm } from '@shared/types';

const searchSchema = z.object({
  token: z.string().catch(''),
});

export const Route = createFileRoute('/pay/')({
  validateSearch: zodSearchValidator(searchSchema),
  component: View,
});

export const PublicPaymentRoute = Route;

function View() {
  const { token } = Route.useSearch();

  const { data: internalPaymentTokenDetails } =
    trpc.payment.getInternalPaymentTokenDetails.useQuery({
      internalPaymentToken: token,
    });

  if (!internalPaymentTokenDetails) return null;

  if (
    internalPaymentTokenDetails.status === 'paid' ||
    internalPaymentTokenDetails.status === 'expired'
  ) {
    return (
      <div className="grid h-screen items-center justify-center">
        <div className="grid gap-4">
          <h1 className="text-2xl font-bold">
            Payment not found or already paid
          </h1>
        </div>
      </div>
    );
  }

  const {
    contact: {
      firstName,
      lastName,
      email,
      contactDetails: { address, zipCode },
    },
    maxAmount,
  } = internalPaymentTokenDetails;

  const defaultValues: CollectPaymentForm = {
    card: {
      number: '',
      exp: '',
      cvv: '',
    },

    billing: {
      firstName: firstName ?? '',
      lastName: lastName ?? '',
      address1: address ?? '',
      zip: zipCode ?? '',
      email: email ?? '',
    },

    payment: {
      amount: maxAmount,
      currency: 'USD',
      isEditable:
        internalPaymentTokenDetails.maxAmount >
        internalPaymentTokenDetails.minAmount,
    },
  };

  return (
    <div className="grid h-screen items-center justify-center">
      <PublicPaymentView
        internalPaymentToken={token}
        defaultValues={defaultValues}
      />
    </div>
  );
}
